export function isWishlistLoginRequired(
  status?: number,
  message?: string,
  requiresLogin?: boolean
): boolean {
  if (requiresLogin) return true;
  if (status === 401) return true;
  const text = (message || '').toLowerCase();
  return text.includes('login') || text.includes('sign in');
}
